"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

var _NavIconModule = _interopRequireDefault(require("./NavIcon.module.scss"));

var _excluded = ["children", "className", "component", "iconSrc", "onClick", "restaurantName", "style", "symbol", "iconType"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var NavIcon = function NavIcon(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? "div" : _ref$component,
      iconSrc = _ref.iconSrc,
      onClick = _ref.onClick,
      restaurantName = _ref.restaurantName,
      style = _ref.style,
      symbol = _ref.symbol,
      iconType = _ref.iconType,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_.ThemeButton, _extends({
    type: iconType,
    className: "".concat(_NavIconModule["default"]["nav-item"], " ").concat(className),
    onClick: onClick
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    className: _NavIconModule["default"].buttonContainer
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    style: style,
    src: iconSrc,
    alt: "".concat(restaurantName, " Icon")
  }))));
};

var _default = NavIcon;
exports["default"] = _default;